import { breadcrumbSchema, webPageSchema } from "@/lib/schema";
import { createFileRoute } from "@tanstack/react-router";
import { FAQS_OASIS } from "@/lib/faqs";
import { waLink } from "@/lib/whatsapp";
import { ogImageMeta } from "@/lib/og-image";
import { PageHero } from "@/components/site/PageHero";
import { PanelSection } from "@/components/site/PanelSection";
import { AccesosRapidos } from "@/components/site/AccesosRapidos";

const TITLE = "Preguntas frecuentes | Residencia Oasis Cuernavaca";
const DESCRIPTION =
  "Respuestas reales sobre costos desde $950 al día, visitas sin horario, demencia, dietas y proceso de ingreso en Residencia Oasis Cuernavaca.";

export const Route = createFileRoute("/preguntas-frecuentes")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://oasiscuernavaca.com/preguntas-frecuentes" },
      ...ogImageMeta(),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: "https://oasiscuernavaca.com/preguntas-frecuentes" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          webPageSchema({ name: "Preguntas frecuentes sobre Residencia Oasis Cuernavaca", description: DESCRIPTION, path: "/preguntas-frecuentes", type: "FAQPage" }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbSchema([{ name: "Preguntas frecuentes", path: "/preguntas-frecuentes" }]),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS_OASIS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  const wa = waLink("preguntas frecuentes", "tengo una duda sobre la estancia");

  return (
    <>
      <PageHero
        breadcrumb="Preguntas frecuentes"
        title="Preguntas Frecuentes sobre Asilos en Cuernavaca"
        answer="Costos desde $950 al día, visitas sin horario y acompañamiento 24 horas."
        waHref={wa}
        waLabel="Preguntar por WhatsApp"
      />

      <PanelSection tone="soft" eyebrow="Dudas" label="Preguntas frecuentes">
        <div className="divide-y divide-border border-t border-border">
          {FAQS_OASIS.map((f) => (
            <details key={f.q} className="py-3">
              <summary className="faq-q">
                <h2 className="faq-h">{f.q}</h2>
              </summary>
              <p className="faq-a">{f.a}</p>
            </details>
          ))}
        </div>
      </PanelSection>

      <AccesosRapidos variant="panel" exclude={["/preguntas-frecuentes"]} />
    </>
  );
}
